import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function YandexIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 13, 13);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m3.5 3.5 3 3.111m0 0 3-3.111m-3 3.111V10.5m6-4a6 6 0 1 1-12 0 6 6 0 0 1 12 0" /></svg>
  );
}

export default YandexIcon;
